import { AlertTriangle } from "lucide-react";
import Reveal from "@/components/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";

export default function RiskDisclosure() {
  const { t } = useLanguage();
  return (
    <section className="px-4 pb-24 sm:px-6 lg:px-8" aria-label={t("risk.title")}>
      <div className="mx-auto max-w-4xl">
        <Reveal>
          <div
            className="rounded-2xl border border-yellow-700/30 bg-[#0D0608] p-6 sm:p-10"
            data-testid="risk-disclosure-card"
          >
            <h2 className="mb-4 flex items-center gap-3 font-display text-lg font-bold uppercase tracking-wide text-yellow-500 sm:text-xl">
              <AlertTriangle size={20} aria-hidden="true" />
              {t("risk.title")}
            </h2>
            <p className="mb-3 text-sm leading-relaxed text-zinc-400">{t("risk.body1")}</p>
            <p className="text-sm leading-relaxed text-zinc-400">{t("risk.body2")}</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
